module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-05.101d914e.png";